<ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
  <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass" *ngIf="child.visible === false ? false : true">
    <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" class="ripplelink"
       *ngIf="!child.routerLink" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
       (mouseenter)="hover=true" (mouseleave)="hover=false">
      <div>{{child.label}}</div>
      <span class="ink" *ngIf="hover"></span>
       <i class="{{child.icon}}" *ngIf="child.items"></i>
    </a>

    <a (click)="itemClick($event,child,i)" class="ripplelink" *ngIf="child.routerLink"
       [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink"
       [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
       (mouseenter)="hover=true" (mouseleave)="hover=false">
      <div>{{child.label}}</div>
      <span class="ink" *ngIf="hover"></span>
       <i class="{{child.icon}}" *ngIf="child.items"></i>
    </a>
    <ul app-barra-lateral-submenu [item]="child" *ngIf="child.items" [parentActive]="isActive(i)" [@children]="isActive(i) ?
                'visible' : 'hidden'" [visible]="isActive(i)"></ul>
  </li>
</ng-template>
